// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonLoader_skeleton__k6IzL"};